import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import NotificationIcon from '@material-ui/icons/Notifications'
import CloseIcon from '@material-ui/icons/Close'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import MessageList from './MessageList'
import { messagesQueries, messagesMongoQueries } from '../graphql/queries'
import { useQuery } from '@apollo/react-hooks'

const useStyles = makeStyles(theme => ({
	margin: {
    margin: theme.spacing(1),
	},
	typography: {
    padding: theme.spacing(2),
	},
	popover: {
		minWidth: 300,
		maxWidth: 350,
		minHeight: 350,
		maxHeight: 450,
		padding: theme.spacing(2)
	},
	popoverTitle: {
    display: 'flex',
    width: '100%',
		flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '85%',
    }
	}
}))

const Messages = () => {
	const classes = useStyles()
	const [anchorEl, setAnchorEl] = React.useState(null);
	const { data } = useQuery(messagesQueries.CHECK_NEW_MESSAGES)
  const { data:dataMongo } = useQuery(messagesMongoQueries.CHECK_NEW_MESSAGES_MONGO)

  const messageSSO = data? data.checkNewMessages : false;
  const messageAprimora = dataMongo? dataMongo.checkNewMessagesMongo : false

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	return (
		<>
			<IconButton aria-describedby={'simple-popover'} aria-label="messages" className={classes.margin} onClick={handleClick}>
				<Badge invisible={messageSSO != messageAprimora ? false: !messageAprimora } badgeContent="" variant="dot" overlap="circle" color="secondary">
					<NotificationIcon />
				</Badge>
			</IconButton>

			<Popover
        id={id}
        open={open}
				anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.popover}>
          <div className={classes.popoverTitle}>
            <Typography variant="subtitle2">Mensagens</Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
          <div>
            <MessageList />
          </div>
         
        </div>
      </Popover>
		</>
	)
}

export default Messages
